import React from 'react';
import { StarIcon, CheckIcon, TagIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  service: {
    id: number;
    title: string;
    description: string;
    image: string;
    rating: number;
    reviewCount: number;
    tags: string[];
    price: string;
  };
}
const ServiceCard: React.FC<ServiceCardProps> = ({
  service
}) => {
  return <Link to={`/services/${service.id}`} data-id="element-501">
      <div className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition" data-id="element-502">
        <div className="relative" data-id="element-503">
          <img src={service.image} alt={service.title} className="w-full h-48 object-cover" data-id="element-504" />
          <div className="absolute top-4 left-4 flex space-x-2" data-id="element-505">
            {service.tags.map((tag, index) => <div key={index} className={`text-xs font-bold px-2 py-1 rounded ${tag === 'Premium' ? 'bg-yellow-500 text-white' : 'bg-[#FF4E00] text-white'}`} data-id="element-506">
                {tag === 'Verified' ? <div className="flex items-center" data-id="element-507">
                    <CheckIcon size={12} className="mr-1" data-id="element-508" />
                    {tag}
                  </div> : <div className="flex items-center" data-id="element-509">
                    <TagIcon size={12} className="mr-1" data-id="element-510" />
                    {tag}
                  </div>}
              </div>)}
          </div>
        </div>
        <div className="p-4" data-id="element-511">
          <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-512">
            {service.title}
          </h3>
          <p className="text-gray-600 text-sm mb-3 line-clamp-2" data-id="element-513">
            {service.description}
          </p>
          <div className="flex items-center mb-3" data-id="element-514">
            <div className="flex items-center mr-2" data-id="element-515">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} size={16} className={`${star <= Math.round(service.rating) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-516" />)}
            </div>
            <span className="text-sm text-gray-600" data-id="element-517">
              {service.rating} ({service.reviewCount} reviews)
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-518">
            <div className="font-bold text-[#FF4E00]" data-id="element-519">{service.price}</div>
            <button className="px-3 py-1 bg-[#FF4E00] text-white text-sm rounded hover:bg-[#e64600] transition" data-id="element-520">
              Book Now
            </button>
          </div>
        </div>
      </div>
    </Link>;
};
export default ServiceCard;